import React, { useEffect, useState } from "react";
import styles from "./BillingHistory.module.css";
import {
  TableContainer,
  Table,
  Box,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useAuthUser } from "react-auth-kit";
import InfiniteScroll from "react-infinite-scroll-component";
import PuffLoader from "react-spinners/PuffLoader";
import { GetPaymentHistoryByPagination } from "../../service/Billing.request";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import styled from "@emotion/styled";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: "14px",
    color: "#fff",
    background: "#073E53",
    textTransform: "capitalize",
    fontWeight: "400",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "10px",
    fontWeight: "400",
    lineHeight: "20px",
    color: "#667085",
  },
}));

function BillingHistory(props: any) {
  const { paymentHistory, paymentInvoice, GetPaymentInvoice, Invoicesuccess } =
    props;
  const auth = useAuthUser();
  const authUser = auth();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasBillingAccess = getSubDomainAccessStatus(
    "MANAGE",
    "BILLING",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const [hasMoreData, setHasMoreData] = useState(false);
  const [items, setItems] = useState<any>();

  useEffect(() => {
    setItems(paymentHistory);
  }, []);

  const handleNextPage = () => {
    const userFromLocalStorage = authUser?.institute[0];
    const lastEvaluatedKey = encodeURIComponent(
      items?.lastEvaluatedKeyReceived?.SK?.S
    );
    const lastEvaluatedSortKey = encodeURIComponent(
      items?.lastEvaluatedKeyReceived?.GSI1SK?.S
    );
    const id = userFromLocalStorage.instituteId;
    const endOfView = window.scrollY + window.innerHeight;
    if (lastEvaluatedKey && endOfView) {
      GetPaymentHistoryByPagination(
        id,
        lastEvaluatedKey,
        10,
        lastEvaluatedSortKey
      )
        .then((res: any) => {
          setHasMoreData(true);
          setItems((prevItems: any) => ({
            returnData: [
              ...prevItems?.returnData,
              ...res?.data?.data?.returnData,
            ],

            lastEvaluatedKeyReceived: res?.data?.data?.lastEvaluatedKeyReceived,
          }));
        })
        .catch((err: any) => {});
    }
  };

  useEffect(() => {
    if (
      items &&
      items?.lastEvaluatedKeyReceived &&
      items?.lastEvaluatedKeyReceived?.SK !== null
    ) {
      setHasMoreData(true);
    } else {
      setHasMoreData(false);
    }
  }, [items]);

  const handleInvoiceDownload = React.useCallback((paymentId: string) => {
    if (paymentId) {
      GetPaymentInvoice(paymentId);
    }
  }, []);

  return (
    <div
      style={{
        minHeight: "calc(100vh - 225px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div className={styles.billingHistoryHead}>Billing History</div>
        <div
          style={{
            margin: "10px 0px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <TableContainer
            sx={{ borderRadius: "8px", border: "1px solid #EAECF0" }}
          >
            <InfiniteScroll
              dataLength={
                items && items?.returnData?.length
                  ? items?.returnData?.length
                  : paymentHistory && paymentHistory?.returnData?.length
              }
              next={handleNextPage}
              hasMore={hasMoreData}
              loader={
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PuffLoader color="#36d7b7" />
                </Box>
              }
              height={470}
            >
              <Table className={styles.billingTable}>
                <TableHead className={styles.billingTableHead}>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Invoice Number</StyledTableCell>
                    <StyledTableCell>Amount</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Invoice</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentHistory?.returnData?.length > 0 &&
                    items?.returnData?.map((column: any) => (
                      <TableRow className={styles.billingHistoryTableRow}>
                        <StyledTableCell>
                          {moment(column.createdDate).format("MMM DD YYYY")}
                        </StyledTableCell>
                        <StyledTableCell>
                          {column?.invoiceNumber
                            ? column.invoiceNumber
                            : column?.proformaInvoiceNumber
                            ? column?.proformaInvoiceNumber
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          <span className={styles.rupee}>₹</span>{" "}
                          {column?.totalCost}
                        </StyledTableCell>
                        <StyledTableCell>
                          <div
                            style={{
                              fontSize: "12px",
                              color:
                                column.status === "Fully Paid"
                                  ? "#12BD93"
                                  : "#EC3939",
                              fontWeight:
                                column.status === "Fully Paid" ? "500" : "400",
                            }}
                          >
                            {column.status}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell className={styles.invoice}>
                          {column.invoiceNumber ||
                          column?.proformaInvoiceNumber ? (
                            <Tooltip
                              arrow
                              title={
                                hasBillingAccess === false
                                  ? "Oops! No permission."
                                  : ""
                              }
                              PopperProps={{ style: { zIndex: 999999 } }}
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "#101828",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    padding: "8px 12px",
                                    "& .MuiTooltip-arrow": {
                                      color: "#101828",
                                    },
                                  },
                                },
                              }}
                            >
                              <span>
                                <div
                                  className={styles.downloadBtn}
                                  onClick={() =>
                                    hasBillingAccess === true
                                      ? handleInvoiceDownload(column.id)
                                      : null
                                  }
                                >
                                  Download
                                </div>
                              </span>
                            </Tooltip>
                          ) : (
                            <span className={styles.empty}>-</span>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </InfiniteScroll>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default BillingHistory;
